import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IconStartConnection,
  Loading,
  useAssetParams,
  useUserinfo,
} from '@mss/mss-component-library';
import { permissionSet } from '../../../authorization/util/permissionSets';
import Button from '../../Button';
import MssIcon from '../../MssIcon';
import useRemoteProfile from '../utils/useProfilesQuery';

type AssetRemoteActionsDetailProps = {
  openConnectModal: (id: string) => void;
};

function AssetRemoteActionsDetail({
  openConnectModal,
}: AssetRemoteActionsDetailProps) {
  const { assetId } = useAssetParams();
  const [t] = useTranslation(['remoteAccess', 'common']);
  const [hasPermission] = useUserinfo(assetId);
  const hasGlobal = hasPermission(permissionSet.remoteAny);
  const profiles = useRemoteProfile();

  if (!hasGlobal && profiles.isLoading) return <Loading />;
  if (hasGlobal || profiles.data?.length)
    return (
      <Button
        onClick={() => openConnectModal(assetId!)}
        className="ml-1"
        data-ta="RemoteConnectButton"
        disabled={!profiles.data?.length}
        loading={profiles.isFetching}
      >
        <MssIcon icon={IconStartConnection} className="mr-1" />
        {t('CONNECT')}
      </Button>
    );
  return <></>;
}

export default AssetRemoteActionsDetail;
